module.exports = __webpack_public_path__ + "7e92510c64face5e6a2e6ae69a67ff1f.png";